<template>
  <div>
    <!-- Button -->
    <v-btn
      :small="$vuetify.breakpoint.xsOnly"
      outlined
      color="primary"
      @click="reportOptionsDialog = true"
    >
      Report Options
      <v-icon
        :small="$vuetify.breakpoint.xsOnly"
        right
        class="ml-2"
      >
        settings
      </v-icon>
    </v-btn>

    <!-- Dialog -->
    <v-dialog
      v-model="reportOptionsDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="py-2">
          <v-toolbar-title>Report Options</v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            color="red"
            class="pa-0 my-0"
            @click="$emit('reset')"
          >
            Reset
          </v-btn>
          <v-btn
            icon
            class="ma-0"
            @click="reportOptionsDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container
            id="report-options-dialog"
            fluid
            grid-list-lg
            pa-0
          >
            <slot />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    reportOptionsDialog: false
  })
}
</script>

<style lang="scss">
#report-options-dialog {
  .v-input--switch .v-input__slot {
    margin-bottom: 0;
  }
}
</style>
